import React from "react";
import { ArrowRight, ShieldCheck, Wind } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WinnipegsCleanAirAuthority() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="29727" id="professional-home-inspections-in-south-florida" ref={ref} className="relative w-full overflow-hidden bg-secondary dark py-16 lg:py-24 xl:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-primary/10 blur-[100px]" />
        <div className="absolute top-[40%] right-[0%] h-[500px] w-[500px] rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-8">
          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-[10px] font-bold tracking-widest text-primary uppercase">
                <ShieldCheck className="h-3 w-3" />
                Licensed & Insured South Florida Home Inspectors
              </div>
              <h1 className="font-sans text-5xl font-extrabold leading-[0.9] tracking-tighter text-white sm:text-6xl md:text-7xl lg:text-[80px] uppercase">
                <span className="block text-primary">PROFESSIONAL</span>
                <span className="block">HOME INSPECTIONS</span>
                <span className="block text-white/70">IN SOUTH FLORIDA</span>
              </h1>
              
              <p className="max-w-[600px] text-lg text-white/80 md:text-[24px] font-sans font-light leading-relaxed">
                Trusted Inspections is a family-owned South Florida home inspection company helping buyers, sellers, realtors, and homeowners make informed decisions with clear, photo-rich reports, practical guidance, and licensed residential inspection services across Trusted Inspections serves South Florida, including Miami-Dade, Broward, the Florida Keys, and premium residential markets such as Coral Gables, South Miami, Palmetto Bay, Pinecrest, Miami Beach, and Fort Lauderdale.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-16 px-12 text-lg font-bold bg-primary text-white shadow-[0_0_20px_rgba(249,115,22,0.3)] hover:shadow-[0_0_30px_rgba(249,115,22,0.5)] transition-all duration-300 rounded-md">
                <Link to="#">
                  Schedule a Home Inspection
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="h-16 px-10 text-base border-2 border-white/20 text-white hover:bg-white/10 hover:text-white rounded-md">
                <Link to="#">Explore Inspection Services</Link>
              </Button>
            </div>

            <p className="text-lg font-medium text-white/70">Licensed inspector. 5+ years experience. Same-day scheduling available.</p>

            <div className="flex flex-wrap items-center gap-x-8 gap-y-4 text-sm text-white/60">
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-primary" />
                <span>Licensed & Insured South Florida Home Inspectors</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-1.5 w-1.5 rounded-full bg-primary" />
                <span>Same-Day Scheduling Available</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-1.5 w-1.5 rounded-full bg-primary" />
                <span>24-Hour Report Delivery</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-[600px] lg:max-w-none transition-all duration-1000 delay-200 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            {}
            <svg className="absolute -top-12 -right-12 -z-10 h-[120%] w-[120%] text-primary/20 animate-pulse duration-[4000ms]" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M50 200C50 100 150 50 250 100C350 150 350 250 250 300C150 350 50 300 50 200Z" stroke="currentColor" strokeWidth="2" strokeDasharray="10 10" className="opacity-50" />
              <path d="M100 200C100 150 150 100 200 125C250 150 250 250 200 275C150 300 100 250 100 200Z" stroke="currentColor" strokeWidth="40" strokeLinecap="round" className="opacity-20 blur-xl" />
              <path d="M350 50C300 150 100 150 50 250" stroke="currentColor" strokeWidth="4" strokeLinecap="round" className="opacity-40" />
            </svg>

            {}
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg bg-secondary shadow-2xl ring-1 ring-white/10 md:aspect-square lg:aspect-[4/5]">
              <div className="absolute inset-0 bg-gradient-to-tr from-secondary/80 to-transparent mix-blend-multiply z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/miami_luxury_home_inspection.png" alt="Modern Miami waterfront home representing Trusted Inspections high-end service" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute bottom-6 left-6 z-20 flex items-center gap-3 rounded-md bg-secondary/95 p-4 shadow-lg backdrop-blur-md border border-white/10">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary">
                  <Wind className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-[10px] font-medium text-white/50 uppercase tracking-widest">Service Area</p>
                  <p className="text-sm font-bold text-white">Serving All South Florida</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}